export default __webpack_public_path__ + "static/media/logo_kplus_4.f97d31c9.svg";